import Icon from '../../components/Icon.vue'

Icon.register({"regular/registered":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56 366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456zM366.4 374.2C313.4 277.9 316.2 282.7 313.2 278.1 337.4 264.2 352.7 236.6 352.7 204.9 352.7 152.4 322.4 119.7 251.2 119.7H172.5C165.9 119.7 160.5 125.1 160.5 131.7V380C160.5 386.6 165.9 392 172.5 392H211.1C217.7 392 223.1 386.6 223.1 380V296.3H255L302.5 385.6A12-12 0 0 1 313.1 392H355.9C365.1 392 370.8 382.2 366.4 374.2zM256.9 239.9H223.1V175.8H250.4C282.9 175.8 289.4 187.9 289.4 207.5 289.4 228.4 277.8 239.9 256.9 239.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/registered.js
// module id = A8TJ
// module chunks = 0